<app-time-off-request-modal
    title="Vacation Request"
    [visible]="visible"
    (visibleChange)="visible = $event; visibleChange.emit($event)"
    [isScreenSmall]="!!(screen.xSmallScreenChanged | async)"
    [height]="'auto'"
    [canEdit]="canEdit"
    [canApprove]="canApprove"
    [canDecline]="canDecline"
    [canWithdrawn]="canWithdrawn"
    (save)="onSave()"
    (close)="close()"
    (statusChange)="changeStatus($event)"
    (shown)="onPopupShown()"
    [timeOffRequest]="request"
>
    @if(this.formData){
        @if (this.formData.status == TimeOffStatus.Pending) {
            @if (conflicts | async; as items) {
                @if (items.length > 0) {
                    <div class="mb-4">
                        <div class="mb-2 fs-7 text-uppercase">Conflicts</div>
                        @for (item of items; track item) {
                            <div class="mb-2 text-danger d-flex align-items-center gap-2">
                                <strong>{{ item.employee?.name }}</strong>
                                <div class="small">{{ item.startDate | date:'longDate':'UTC' }}- {{ item.endDate | date:'longDate':'UTC' }}
                                </div>
                            </div>
                        }
                    </div>
                }
            }
        }
        <dx-form>
            <dxi-item>
                <label class="form-label">Employee*</label>
                <pictured-item-select-box
                    [value]="formData.employee.id"
                    (valueChange)="onEmployeeChange($event)"
                    [dataSource]="employeesDataSource"
                    [readOnly]="!canEditEmployee"
                ></pictured-item-select-box>
            </dxi-item>
            <dxi-item>
                <dx-date-range-box
                    stylingMode="filled"
                    [(startDate)]="formData.requestedStartDate"
                    [(endDate)]="formData.requestedEndDate"
                    (startDateChange)="onStartDateChange($event)"
                    (endDateChange)="onEndDateChange($event)"
                    [readOnly]="!canEdit"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-date-range-box>
            </dxi-item>
            <dxi-item>
                <strong>Vacation Day(s) Requested:</strong>
                @if (formData.workingDays) {
                    {{ formData.workingDays }}
                } @else {
                    {{ daysRequested | async }}
                }
            </dxi-item>
            <dxi-item>
                <strong>Vacation Day(s) Available:</strong>
                @if (employeeBalance | async; as balance) {
                    {{ balance.vacationDaysAvailable }}
                }
            </dxi-item>
            <dxi-item>
                <dx-text-area
                    label="Description*"
                    stylingMode="filled"
                    [height]="70"
                    [(value)]="formData.description"
                    [readOnly]="!canEdit"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-area>
            </dxi-item>
        </dx-form>
    }

</app-time-off-request-modal>
